<template>
  <b-row>
    <b-col md="12">
      <ul class="heading-ul">
        <li>
          <router-link to="/setup/Resources" class="mr-2">
            <i
              class="fa fa-arrow-left"
              aria-hidden="true"
              style="font-size: 18px; color: #262626"
            ></i>
          </router-link>
        </li>
        <li><h3>Edit Currency</h3></li>
      </ul>
    </b-col>
    <b-col md="12" class="pb-0 pt-0">
      <b-card class="custome-card mb-3">
        <b-row v-if="renderIsCurrencyData">
          <b-col md="6">
            <!-- <b-form-input
              inputType="text"
              placeholder="Currency"
              class="mt-0"
              v-model="currency"
            /> -->
            <div class="form-group">
              <eb-select
                type="select"
                :options="resourceData"
                label="resourceCode"
                id="ResourceCode"
                placeholder="Currency"
                class="mt-0"
                v-model="currency"
                :selected="currency"
                @input="onSelectCode(currency)"
              ></eb-select>
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="Currency Name"
                class="mt-0"
                v-model="currencyName"
              />
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="Currency Symbol"
                class="mt-0"
              />
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="resourceID"
                class="mt-0"
                v-model="resourceID"
              />
            </div>
          </b-col>
        </b-row>

        <b-row v-if="!renderIsCurrencyData">
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="Currency"
                class="mt-0"
                v-model="currency"
              />
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="Currency Name"
                class="mt-0"
                v-model="currencyName"
              />
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="Currency Symbol"
                class="mt-0"
              />
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group">
              <b-form-input
                inputType="text"
                placeholder="resourceID"
                class="mt-0"
                v-model="resourceID"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12" v-if="renderIsCurrencyData">
      <h3>Add Currency Exchange Rate</h3>
    </b-col>
    <b-col md="12" class="pb-0 pt-0" v-if="renderIsCurrencyData">
      <b-card class="custome-card mb-3">
        <b-row>
          <b-col md="3">
            <eb-select
              placeholder="Select Currency"
              label="text"
              type="select"
              :selected="selectCurrency"
              v-model="selectCurrency"
              @input="selectCurrencyData(selectCurrency)"
              :options="resourceCurrency"
            >
            </eb-select>
          </b-col>
          <b-col md="3">
            <b-form-input
              inputType="number"
              placeholder="Enter Exchange Rate"
              class="mt-0"
              v-model="exchangeRate"
            />
          </b-col>
          <b-col md="3">
            <b-form-input
              type="date"
              id="activation-startDate"
              v-model="effetiveStartDate"
            >
            </b-form-input>
          </b-col>
          <b-col md="3">
            <b-input
              type="date"
              id="activation-endDate"
              v-model="effetiveEndDate"
            >
            </b-input>
          </b-col>
          <b-col md="12" class="text-right"
            ><button
              type="button"
              class="btn btn-primary w-10"
              classic="mr-1 btn-primary"
              text="Save"
              @click="addCurrencyData"
            >
              Add Currency
            </button></b-col
          >
        </b-row>
      </b-card>
    </b-col>
    <b-col md="12" v-if="renderIsCurrencyData">
      <b-card class="custome-card">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="showExchangeRate"
            :fields="currencyAddPage"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            @filtered="onFilter"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="updatedAt" slot-scope="data">
              <div>{{ data.item.updatedAt | formatedate }}</div>
            </template>
            <template slot="empty">
              <div v-if="loading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
            <template slot-scope="data" slot="action">
              <div class="inline_btnTable">
                <b-button
                  size="sm"
                  class="mr-2 butto-circle"
                  @click="onClickDelete(data.index)"
                  variant="danger"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <div class="text-center mb-5 mt-2 p-4">
        <button
          type="button"
          class="text-uppercase btn btn-lg btn-outline-primary mr-3 w-15"
          @click="backToResources"
        >
          Cancel
        </button>
        <button
          type="button"
          class="text-uppercase btn btn-lg btn-primary ml-3 w-15"
          classic="mr-1 btn-primary"
          text="Save"
          @click="addCurrencyEvent"
        >
          Update
        </button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import Vue from "vue";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import { resourcesCurrency } from "@/utils/resourcesCurrency";
import currency from "@/store/currency";
export default {
  name: "editCurrency",
  data() {
    return {
      filterCount: 0,
      loading: false,
      perPage: 10,
      currentPage: 1,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "updatedAt",
      sortDesc: true,
      showExchangeRate: [],
      currencyAddPage: [
        {
          key: "code",
          label: "Currency",
        },
        {
          key: "rate",
          label: "Exchange Rate",
        },
        {
          key: "startDate",
          label: "Effective Start Date",
          formatter: "formateStartdate",
        },
        {
          key: "endDate",
          label: "Effective End Date",
          formatter: "formateStartdate",
        },
        {
          key: "action",
          label: "Action",
          thStyle: { width: "8%" },
        },
      ],
      currency: "",
      currencyName: "",
      selectCurrency: "",
      exchangeRate: null,
      effetiveStartDate: "",
      effetiveEndDate: "",
      resourceID: "",
      rate: "",
      startDate: "",
      endDate: "",
      isCurrency: false,
      selectedCurrency: {},
    };
  },
  components: {
    ebSelect,
    loader,
  },
  computed: {
    ...mapState({
      fetchCurrencyList: (state) => state.currency.fetchCurrencyList,
    }),
    resourceData() {
      return resourcesCurrency;
    },
    renderIsCurrencyData() {
      let data = this.fetchCurrencyList.find(
        (currencyData) => currencyData._id === this.$route.params.id
      );
      this.isCurrency = data.isCurrency;
      return data.isCurrency;
    },
    resourceCurrency() {
      let currencyVar = [];
      this.fetchCurrencyList.forEach((currencyDetails) => {
        if (currencyDetails.isCurrency === true) {
          currencyVar.push({
            text: currencyDetails.code,
            value: currencyDetails._id,
          });
        }
      });
      const unique = [
        ...new Map(currencyVar.map((item) => [item.text, item])).values(),
      ];
      return unique;
    },
  },
  methods: {
    onSelectCode(e) {
      this.currency = e.resourceCode;
      this.currencyName = e.resourceName;
      this.resourceID = e.resourceId;
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    async addCurrencyEvent() {
      if (this.isCurrency) {
        let payload = {
          resourceID: this.resourceID,
          code: this.currency,
          name: this.currencyName,
          isCurrency: this.isCurrency,
          exchangeRates: [
            {
              resource: {
                _id: this.selectedCurrency?.value,
                code: this.selectedCurrency?.text,
              },
              startDate: this.effetiveStartDate,
              endDate: this.effetiveEndDate,
              rate: this.exchangeRate,
            },
          ],
          _id: this.$route.params.id,
        };
        await this.$store
          .dispatch("currency/currencyEditAction", payload)
          .then(async (res) => {
            this.currency = "";
            this.currencyName = "";
            this.selectCurrency = "";
            this.exchangeRate = null;
            this.effetiveStartDate = "";
            this.effetiveEndDate = "";
            this.$router.push("/setup/Resources");
          });
      } else {
        let payload = {
          resourceID: this.resourceID,
          code: this.currency,
          name: this.currencyName,
          isCurrency: this.isCurrency,
          _id: this.$route.params.id,
        };
        await this.$store
          .dispatch("currency/currencyEditAction", payload)
          .then(async (res) => {
            this.currency = "";
            this.currencyName = "";
            this.selectCurrency = "";
            // this.exchangeRate = null;
            // this.effetiveStartDate = "";
            // this.effetiveEndDate = "";
            this.$router.push("/setup/Resources");
          });
      }
    },
    async fetchEditItemDetails() {
      let editData = this.fetchCurrencyList.find(
        (currencyData) => currencyData._id === this.$route.params.id
      );
      this.showExchangeRate = editData?.exchangeRates.map((e) => {
        return {
          id: e._id,
          code: e.resource.code,
          rate: e.rate,
          startDate: e.startDate.slice(0, 10),
          endDate: e.endDate.slice(0, 10),
        };
      });
      return this.showExchangeRate;
    },
    addCurrencyData() {
      if (this.showExchangeRate.length > 0) {
        const addedStartDate =
          this.showExchangeRate[this.showExchangeRate.length - 1].startDate ===
          this.effetiveStartDate;
        const addedEndDate =
          this.showExchangeRate[this.showExchangeRate.length - 1].endDate ===
          this.effetiveEndDate;
        if (addedStartDate && addedEndDate) {
          this.showCustomToast1();
        } else {
          let currencyExchangeData = {
            code: this.selectCurrency,
            rate: this.exchangeRate,
            startDate: this.effetiveStartDate,
            endDate: this.effetiveEndDate,
          };
          this.showExchangeRate.push(currencyExchangeData);
        }
      } else {
        if (this.effetiveStartDate == "") {
          this.showCustomToast2();
        }
        let currencyExchangeData = {
          code: this.selectCurrency,
          rate: this.exchangeRate,
          startDate: this.effetiveStartDate,
          endDate: this.effetiveEndDate,
        };
        this.showExchangeRate.push(currencyExchangeData);
      }
    },
    showCustomToast1() {
      Vue.toasted.show("Please Add Time period.", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 10000,
      });
    },
    showCustomToast2() {
      Vue.toasted.show(
        "The exchange rate had already been added during that period.",
        {
          type: "info",
          theme: "toasted-primary",
          singleton: true,
          duration: 10000,
        }
      );
    },
    onClickDelete(index) {
      this.showExchangeRate.splice(index, 1);
    },
    selectCurrencyData(e) {
      this.selectCurrency = e.text;
    },
    backToResources() {
      this.$router.push("/setup/Resources");
    },
  },

  async mounted() {
    this.fetchEditItemDetails();
    await this.$store.dispatch("currency/fetchCurrencySetupList");
    let editData = this.fetchCurrencyList.find(
      (currencyData) => currencyData._id === this.$route.params.id
    );
    this.currency = editData.code;
    this.currencyName = editData.name;
    this.resourceID = editData.resourceID;
    this.selectCurrency = editData.code;
    let currencyDropdown = this.resourceCurrency.find(
      (el) => this.selectCurrency === el.text
    );
    this.selectedCurrency = currencyDropdown;
    this.exchangeRate = editData?.exchangeRates[0]?.rate;
    this.effetiveStartDate = editData?.exchangeRates[0]?.startDate;
    this.effetiveEndDate = editData?.exchangeRates[0]?.endDate;
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>
<style scoped>
.heading-ul {
  padding: 0;
}
.heading-ul li {
  list-style: outside none;
  display: inline-block;
  margin-right: 10px;
}
</style>
